import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import esCo from '@angular/common/locales/es-CO';
import { ApplicationConfig, DEFAULT_CURRENCY_CODE, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { es_ES, provideNzI18n } from 'ng-zorro-antd/i18n';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations, BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { ErrorCatchingInterceptorFn } from '@core/interceptors/error-catching-fn.interceptor';
import { TokenInterceptorFn } from '@core/interceptors/token-fn.interceptor';
import { UI_DATE_FORMAT } from '@core/constants/date-format.constant';
import { APP_CURRENCY, APP_LOCALE } from '@core/constants/locale.constant';

registerLocaleData(esCo);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideNzI18n(es_ES),
    { provide: LOCALE_ID, useValue: APP_LOCALE },
    { provide: DEFAULT_CURRENCY_CODE, useValue: APP_CURRENCY },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: UI_DATE_FORMAT } },
    provideAnimations(),
    provideHttpClient(withInterceptors([
      ErrorCatchingInterceptorFn,
      TokenInterceptorFn
    ])),
    importProvidersFrom([
      BrowserAnimationsModule,
      BrowserModule,
      FormsModule
    ]),
  ]
};
